/*************************************************/
/* LANGUAGE                                      */
/*************************************************/

export function language() {
    const languageSelector = document.querySelector(".language-selector");
    const currentLangButton = languageSelector ? languageSelector.querySelector('.language-selector__current') : null;
    const langList = languageSelector ? languageSelector.querySelector('.language-selector__list') : null;
    const overlay = document.querySelector(".overlay");

    const firstLangLink = langList ? langList.querySelector('.language-selector__list-link') : null;
    const body = document.body;
    const visibleClass = "language-selector--visible";
    const openOverlayClass = "overlay--open";
    const noScrollClass = "no-scroll";
    const ariaExpandedAttr = "aria-expanded";
    const ariaHiddenAttr = "aria-hidden";

    if (!languageSelector || !currentLangButton || !langList || !firstLangLink || !overlay) {
        console.error("Language selector elements not found.");
        return;
    }

    const openLanguageSelector = () => {
        languageSelector.classList.add(visibleClass);
        currentLangButton.setAttribute(ariaExpandedAttr, "true");
        langList.setAttribute(ariaHiddenAttr, "false");
        overlay.classList.add(openOverlayClass);
        body.classList.add(noScrollClass);
    };

    const closeLanguageSelector = (returnFocus = true) => {
        languageSelector.classList.remove(visibleClass);
        currentLangButton.setAttribute(ariaExpandedAttr, "false");
        langList.setAttribute(ariaHiddenAttr, "true");
        overlay.classList.remove(openOverlayClass);
        body.classList.remove(noScrollClass);

        if (returnFocus) {
            currentLangButton.focus();
        }
    };

    const init = function () {
        langList.setAttribute(ariaHiddenAttr, "true");

        currentLangButton.addEventListener('click', e => {
            e.stopPropagation();

            const isOpen = languageSelector.classList.contains(visibleClass);

            if (isOpen) {
                closeLanguageSelector();
            } else {
                openLanguageSelector();

                if (e.detail === 0 || e.detail === undefined) {
                    setTimeout(() => {
                        firstLangLink.focus();
                    }, 10);
                }
            }
        });

        // CLICK OUTSIDE LISTENER 
        document.addEventListener('click', e => {
            const isOpen = languageSelector.classList.contains(visibleClass);
            const isClickInsideSelector = langList.contains(e.target);

            if (isOpen && !isClickInsideSelector) {
                closeLanguageSelector();
            }
        });

        // KEYDOWN LISTENERS 
        document.addEventListener('keydown', e => {
            const isOpen = languageSelector.classList.contains(visibleClass);

            if (isOpen && e.key === "Escape") {
                closeLanguageSelector();
            }
        });

        // FOCUSOUT LISTENER
        languageSelector.addEventListener('focusout', e => {
            if (e.relatedTarget === null) return;

            const isOpen = languageSelector.classList.contains(visibleClass);

            setTimeout(() => {
                if (isOpen && !languageSelector.contains(document.activeElement)) {
                    closeLanguageSelector(false);
                }
            }, 0);
        });
    };

    init();
}